import * as React from 'react';
import { ButtonContainer, Button, usePagination } from '../../../../components';
import { getDefaultQuickFilter } from './applicationViewTableFunctions';
import { type QuickFilter } from './types';

export type ApplicationViewQuickFiltersProps = {
  quickFilters?: QuickFilter[];
  onAppliedQuickFilterChange?: (filter: QuickFilter['filter']) => void;
};

export const ApplicationViewQuickFilters: React.FunctionComponent<
  ApplicationViewQuickFiltersProps
> = props => {
  const { quickFilters, onAppliedQuickFilterChange } = props;
  const { clearPagination } = usePagination();
  const defaultFilterId = getDefaultQuickFilter(quickFilters)?.id;
  const [appliedQuickFilterId, setAppliedQuickFilterId] =
    React.useState(defaultFilterId);
  const handleQuickFilterClick = (quickFilter: any) => () => {
    setAppliedQuickFilterId(quickFilter.id);
    onAppliedQuickFilterChange &&
      onAppliedQuickFilterChange(quickFilter.filter);
    // clear pagination info after change quick filter
    clearPagination();
  };
  return (
    <ButtonContainer
      width={'100%'}
      display={'flex'}
      justifyContent={'start'}
      spacing={{ xs: 1 }}
    >
      {quickFilters?.map(quickFilter => {
        const { text, id } = quickFilter;
        return (
          <Button
            key={`${text}`}
            onClick={handleQuickFilterClick(quickFilter)}
            className="!normal-case"
            variant={appliedQuickFilterId === id ? 'contained' : 'outlined'}
          >
            {text}
          </Button>
        );
      })}
    </ButtonContainer>
  );
};
